module.exports = __webpack_public_path__ + "media/images/compare-img2-ec6049250974fb9dd8653ff47e07649a.png";